import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ps-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.scss']
})
export class EnquiryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
